/** @module csi/image/ImageRotateLeft **/
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton",
	"csi/image/ImageEditorPluginMixin"
], function(lang,Action,PluginFactory,ToolbarPluginButton,ImageEditorPluginMixin) {

	return PluginFactory.declare("rotateleft", [ToolbarPluginButton, ImageEditorPluginMixin], {
		/**
		 * Set the action for rotating
		 */
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ImageEditorRotate",
				m_onAction: "rotateLeft"
			});
			this.defAction.setMaterialIcon("rotate_left");
			this.defAction.resolve();
		}
	});
});